import { render, staticRenderFns } from "./t5.vue?vue&type=template&id=644dd092&scoped=true"
import script from "./t5.vue?vue&type=script&lang=js"
export * from "./t5.vue?vue&type=script&lang=js"
import style0 from "./t5.vue?vue&type=style&index=0&id=644dd092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644dd092",
  null
  
)

export default component.exports